import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {TranslationService} from '../services/translation.service';

const DATE_FORMAT = 'MMM d, y';
const DE_TIME_FORMAT = 'HH:mm';
const EN_TIME_FORMAT = 'h:mm';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {


  constructor(
    private translate: TranslateService,
    private translationService: TranslationService) {
    super(translationService.getLocale());
  }

  transform(date: Date): any {
    if (isToday(date)) {
      return this.translate.instant('shared.today-at') + ' ' + super.transform(date, this.getTimeFormat());
    } else {
      return super.transform(date, this.getFormat());
    }
  }

  private getFormat() {
    return DATE_FORMAT + ', ' + this.getTimeFormat();
  }

  private getTimeFormat() {
    return this.translationService.getCurrentLanguage() === 'de' ? DE_TIME_FORMAT : EN_TIME_FORMAT;
  }
}

const isToday = (someDate) => {
  const today = new Date();
  return someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear();
};
